<button
  mat-button
  color="accent"
  class="text-uppercase"
  data-cy="clear-all-filters-button"
  aria-label="Clear All Filters"
  (click)="filterService.clearFilterBarFilters()">
  Clear All
</button>
